module.exports = __webpack_public_path__ + "img/recommended_03.d86cc48f.webp";